import { useEffect, useMemo, useState } from 'react';

import { removeAll } from '@moniebook-web/utils';
import { useNavigate } from 'react-router';

import { GHOST_SESSION_PAGES } from '../constants';
import { useSessionTokenPayload } from '../context/session-token-payload-context';

const ONE_SECOND_MS = 1000;

export const useGhostSessionExpiry = () => {
    const { isGhostSession, sessionStartsAt, sessionExpiresAt } =
        useSessionTokenPayload();
    const navigate = useNavigate();
    const [remainingMs, setRemainingMs] = useState<number | null>(null);

    useEffect(() => {
        if (!isGhostSession || !sessionExpiresAt) {
            return;
        }

        const tick = () => {
            const remaining = sessionExpiresAt - Date.now();

            if (remaining <= 0) {
                removeAll();
                navigate(GHOST_SESSION_PAGES.EXPIRED, { replace: true });
                return;
            }

            setRemainingMs(remaining);
        };

        tick();
        const intervalId = setInterval(tick, ONE_SECOND_MS);

        return () => clearInterval(intervalId);
    }, [isGhostSession, sessionExpiresAt, navigate]);

    const percentageSpent = useMemo(() => {
        if (!sessionExpiresAt || !sessionStartsAt || !remainingMs) return 0;
        const duration = sessionExpiresAt - sessionStartsAt;
        return (1 - remainingMs / duration) * 100;
    }, [sessionExpiresAt, sessionStartsAt, remainingMs]);

    return { remainingMs, percentageSpent };
};
